import LocalStorage from '../utils/localStorage';

const metodos = {
  atribuir: (chave, valor) => LocalStorage.atribuir(chave, valor),
  obter: chave => LocalStorage.obter(chave),
  remover: (...chaves) => LocalStorage.remover(chaves),
  limparRegistros: () => { LocalStorage.limparRegistros(); },
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$localStorage = metodos;
  },
};

export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/localStorage.js